import {assert} from 'Asserts';
import APIUtil from 'util/APIUtil';

import {SmartChipType} from './SmartChipTypes';

export function maybeGetSmartChipTypeFromId(id: string): SmartChipType | null {
  if (APIUtil.isAnalysis(id)) {
    return SmartChipType.ANALYSIS;
  } else if (APIUtil.isAnalysisTemplate?.(id)) {
    return SmartChipType.ANALYSIS_TEMPLATE;
  } else if (APIUtil.isAutomationOutputFile(id)) {
    return SmartChipType.AUTOMATION_OUTPUT_FILE;
  } else if (APIUtil.isBiologicalEntity(id) || APIUtil.isMolecule(id)) {
    return SmartChipType.BIOENTITY;
  } else if (APIUtil.isBulkAssembly(id)) {
    return SmartChipType.BULK_ASSEMBLY;
  } else if (APIUtil.isConnection(id)) {
    return SmartChipType.CONNECTION;
  } else if (APIUtil.isDataset(id)) {
    return SmartChipType.DATASET;
  } else if (APIUtil.isDocument(id)) {
    return SmartChipType.DOCUMENT;
  } else if (APIUtil.isEntry(id)) {
    return SmartChipType.ENTRY;
  } else if (APIUtil.isFile(id)) {
    return SmartChipType.FILE;
  } else if (APIUtil.isParty(id)) {
    return SmartChipType.PARTY;
  } else if (APIUtil.isProcedure(id)) {
    return SmartChipType.PROCEDURE;
  } else if (APIUtil.isProcedureMethodExecutionInstance(id)) {
    return SmartChipType.PROCEDURE_METHOD_EXECUTION_INSTANCE;
  } else if (APIUtil.isProcedureRun(id)) {
    return SmartChipType.PROCEDURE_RUN;
  } else if (APIUtil.isProcess(id)) {
    return SmartChipType.PROCESS;
  } else if (APIUtil.isProcessOutput(id)) {
    return SmartChipType.PROCESS_OUTPUT;
  } else if (APIUtil.isProcessTask(id)) {
    return SmartChipType.PROCESS_TASK;
  } else if (APIUtil.isRequest(id)) {
    return SmartChipType.REQUEST;
  } else if (APIUtil.isRequestV2Submission(id)) {
    return SmartChipType.REQUEST_V2_SUBMISSION;
  } else if (APIUtil.isRun(id)) {
    return SmartChipType.RUN;
  } else if (APIUtil.isAssaySchema(id)) {
    return SmartChipType.RUN_SCHEMA;
  } else if (APIUtil.isSampleDefinition(id)) {
    return SmartChipType.SAMPLE_DEFINITION;
  } else if (APIUtil.isStorable(id)) {
    return SmartChipType.STORABLE;
  } else if (APIUtil.isStorableSchema(id)) {
    return SmartChipType.STORABLE_SCHEMA;
  } else if (APIUtil.isStageEntry(id)) {
    return SmartChipType.STAGE_ENTRY;
  } else if (APIUtil.isStudy(id)) {
    return SmartChipType.STUDY;
  } else if (APIUtil.isTagSchema(id)) {
    return SmartChipType.TAG_SCHEMA;
  } else if (APIUtil.isEntryTemplate(id)) {
    return SmartChipType.TEMPLATE;
  } else if (APIUtil.isTestDefinition(id)) {
    return SmartChipType.TEST_DEFINITION;
  } else if (APIUtil.isTestOrder(id)) {
    return SmartChipType.TEST_ORDER;
  } else if (APIUtil.isWorklist(id)) {
    return SmartChipType.WORKLIST;
  } else if (APIUtil.isWorksheet(id)) {
    return SmartChipType.WORKSHEET;
  }
  return null;
}

export function getSmartChipTypeFromId(id: string): SmartChipType {
  const type = maybeGetSmartChipTypeFromId(id);
  assert(type != null, `Unexpected chip type with id='${id}'`);
  return type;
}
